import { toIcons } from '../../consts/Paths';

const SearchBar = (props: any) => {
    const isStringType = () => {
        if (typeof props.width === typeof 'string') {
            return true;
        } else return false;
    };
    return (
        <div className='searchbar-notify'>
            {props.register ? (
                <input
                    style={{
                        width: isStringType() ? `${props.width}` : `${props.width}px`,
                    }}
                    className='searchbar-input'
                    {...props.register('name')}
                    placeholder='Search'
                    defaultValue={props.defaultValue}
                />
            ) : (
                <input id="searchkeyword" style={{ width: `${props.width}px` }} className='searchbar-input' />
            )}
            
            {props.notify && (
                <div className='Oval'>
                    <img className='notify-icon' src={`${toIcons}/notifications.svg`} />
                </div>
            )}
        </div>
    );
};
export default SearchBar;
